var _ = require('underscore');
var Marionette = require('marionette');
var Dropdown = require('Dropdown');
var Confirmation = require('DialogConfirmation');
var Entities = require('Entities');
var Resources = EY.Consultation.Resources;
var User = EY.Consultation.CurrentUser;
var Labels = EY.Consultation.Labels;
var sha1 = require('sha1');
var Export = require('ExportTopics');
var ExportNode = require('ExportNode');


var fields = function () {
    return [
        { value: 'area', label: Labels.Area },
        { value: 'region', label: Labels.Region },
        { value: 'country', label: Labels.Country },
        { value: 'recordType', label: Labels.RecordType },
        { value: 'typeText', label: Labels.Topic },
        { value: 'subTypeText', label: Labels.Subtopic1 },
        { value: 'subjectText', label: Labels.Subject }];
};

var AddEdit = Marionette.View.extend({
    collectionEvents: {
        'reset add remove': 'render'
    },
    events: {
        'click @ui.edit': 'edit',
        'click @ui.add': 'add',
        'click @ui.cancel': 'cancel',
        'click @ui.save': 'dialog',
        'click @ui.delete': 'remove'
    },
    regions: {
        dropdown: '#dropdown'
    },
    template: '#addEdit',
    ui: {
        label: 'label',
        add: '#add',
        cancel: '#cancel',
        edit: '#edit',
        delete: '#delete',
        save: '#save',
        selection: '#selection',
        editor: '#editor',
        input: 'input'
    },
    onRender: function() {
        var context = this;
        var options = this.options;

        this.ui.label.html(options.label);
        this.model = new Entities.Classification();

        Dropdown.show({
            autoselect: true,
            collection: this.collection,
            region: this.getRegion('dropdown'),
            onSelectionChanged: function(selection) {
                if (options.childCollection) {
                    options.childCollection.reset(options.childCollectionSource.filter(function(child) {
                        return child.id.indexOf(selection.id) === 0;
                    }));
                }
                if (selection && selection.id) {
                    context.model = selection;
                }
            }
        });
    },
    cancel: function() {
        this.ui.input.val('');
        this.toggle();
    },
    add: function () {
        var parent = this.options.parentCollection.findWhere({ selected: true });
        var type = this.options.type;

        if (parent) {
            this.ui.input.val('');
            this.model = new Entities.Classification({
                parentId: parent.id,
                type: type,
                typePath: parent.get('typePath') + type + '/'
            });
            this.toggle();
        }
    },
    edit: function () {
        if (this.model.id) {
            this.ui.input.val(this.model.get('text'));
            this.toggle();
        }
    },
    dialog: function () {
        var context = this;

        if (!this.model.id) {
            this.save();
        } else {
            Confirmation.show({ message: Labels.DialogClassification }).done(function() {
                context.save();
            });
        }
    },
    save: function () {
        var context = this;
        var text = this.ui.input.val().trim();
        var options = {};

        if (text !== '') {
            if (!this.model.id) {
                var id = text.replace(/[~`!@#$%^&\*()_\+={\[}\]\|\\:;""'<,>\.\?/ ]/g, '');

                id = this.model.get('parentId') + (id.length > 40 ? sha1(id) : id) + '/';
                this.model.set('_id', id);
            } else {
                options = { url: window.encodeURI(this.model.urlRoot + '?id=' + this.model.id) };
            }
            this.log(this.model.get('_id'), this.model.get('text'), text);
            this.model.set('text', text);
            this.model.save({}, options).done(function (response) {
                context.ui.input.val('');
                context.toggle();
                context.collection.add(response);
                context.options.collectionClone.add(response);
            });
        }
    },
    remove: function () {
        var context = this;

        if (this.model.id) {
            Confirmation.show({ message: Labels.DialogClassification }).done(function() {
                if (context.options.childCollection) {
                    context.options.childCollection.each(function (child) {
                        context.log(child.id, child.get('text'));
                        child.destroy({ wait: true, url: window.encodeURI(context.model.urlRoot + '?id=' + child.id) });
                    });
                }
                context.log(context.model.id, context.model.get('text'));
                context.model.destroy({ url: window.encodeURI(context.model.urlRoot + '?id=' + context.model.id) });
            });

        }
    },
    toggle: function () {
        this.ui.selection.toggleClass('hidden');
        this.ui.editor.toggleClass('hidden');
    },
    log: function (classificationId, oldText, newText) {
        var audit = new Entities.ClassificationAudit({ classificationId: classificationId, oldText: oldText, newText: newText });
        audit.save();
    }
});

var Layout = Marionette.View.extend({
    events: {
        'click @ui.export': 'export'
    },
    regions: {
        country: '#country',
        recordType: '#recordType',
        type: '#type',
        subtype: '#subtype',
        subject: '#subject',
        subtopic1: '#Subtopic1',
        subtopic2: '#Subtopic2'
    },
    template: '#classificationLayout',
    className: 'manageTopics',
    ui: {
        'export': '#exportTopic'
    },
    'export': function () {
        Export.run(this.options);
        //ExportNode.send({ collection: this.options.searchedTopics, fields: fields(), fileName: Labels.ExportRecordsFileName });
    }
});

var classifications = function (options) {
    var layout = options.layout;
    var subjects = new Entities.Classifications();
    var subtypes = new Entities.Classifications();
    var types = options.types;
    var context = options;

    Dropdown.show({
        collection: types,
        region: layout.getRegion('type'),
        onSelectionChanged: function (type) {
            subtypes.reset(context.subtypes.filter(function (subtype) {
                return subtype.id.indexOf(type.id) === 0;
            }));

        }
    });

    layout.getRegion('subtopic1').show(new AddEdit(_.extend({ type: 'Subtype', label: EY.Consultation.Labels.Subtype, collection: subtypes, collectionClone: context.subtypes, parentCollection: types, childCollection: subjects, childCollectionSource: options.subjects }, options)));
    layout.getRegion('subtopic2').show(new AddEdit(_.extend({ type: 'Subject', label: EY.Consultation.Labels.Subject, collection: subjects, collectionClone: context.subjects, parentCollection: subtypes }, options)));
};

var configure = function (options) {
    var filter = options.filter;
    var subjects = options.subjects;
    var subtypes = options.subtypes;
    var types = options.types;
    var collection = new Entities.Classifications();
    var criteria = '/' + _.last(filter.get('countryId').slice(1, -1).split('/')) + '/' + filter.get('recordTypeId').replace('_', "") + '/';

    return collection.fetch({
        filter: { _id: { $regex: criteria, $options: 'i' } }
    }).done(function () {
        var classificationByType = collection.groupBy('type');

        types.reset(classificationByType.Type);
        subtypes.reset(classificationByType.Subtype);
        subjects.reset(classificationByType.Subject);
    });
};

module.exports.start = function () {
    var consultation = require('Consultation');
    var filter = new Backbone.Model();
    var subjects = new Entities.Classifications();
    var subtypes = new Entities.Classifications();
    var types = new Entities.Classifications();
    var searchedTopics = new Backbone.Collection();
    var layout = new Layout({ searchedTopics: searchedTopics });
    var options = { types: types, subtypes: subtypes, subjects: subjects, filter: filter, layout: layout, searchedTopics: searchedTopics };
    consultation.show({ view: layout });
    Dropdown.show({
        collection: new Entities.Geographies(Resources.CountriesFiltered.filter(function (item) {
            return User.roles && User.roles.length > 0 && new RegExp(User.adminGeography).test(item.id);
        })),
        region: layout.getRegion('country'),
        onSelectionChanged: function (country) {
            filter.set('countryId', country.id);
        }
    });

    Dropdown.show({
        collection: new Entities.Enumerations(_.filter(Resources.Enumeration, { type: 'RecordType' })),
        region: layout.getRegion('recordType'),
        resourceKeyAttribute: 'id',
        onSelectionChanged: function (recordType) {
            filter.set('recordTypeId', recordType.id);
        }
    });
    classifications(options);

    filter.on('change', function () {
        if (filter.get('countryId') && filter.get('recordTypeId')) {
            configure(options).done(function () {
                classifications(options);
            });
        }
    });

    //Export.run(options);

};


// WEBPACK FOOTER //
// ./js/Modules/Classification/Classification.js